/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Artifact_Visitor_Allowlist_LabelInputs */



/**
* | output |
* | --- |
* | "Who may sign in" |
*
* @param {Artifact_Visitor_Allowlist_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const artifact_visitor_allowlist_label = /** @type {((inputs?: Artifact_Visitor_Allowlist_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Artifact_Visitor_Allowlist_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Wer sich anmelden darf")
	return /** @type {LocalizedString} */ ("Who may sign in")
});